import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, mergeMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isPPUOriginUrl = (req: any) => {
    if (req.url.startsWith(environment.API_ROOT)) {
      return true;
    }
    return false;
  };

  const processErrorMessages = (error: any) => {
    const errorMessages: Array<string> = [];
    if (error.error) {
      if (!!error.error.errors) {
        Object.keys(error.error.errors).forEach((key) => {
          errorMessages.push(error.error.errors[key]);
        });
      } 
      else if(error.statusText === "Unknown Error" && error.status === 0){
        errorMessages.push("Too Many Requests. Please try again later - Trop de requêtes. Veuillez réessayer plus tard");
      }
      else {
        errorMessages.push(error.error.message ?? "Something went wrong. Please try again - Une erreur s'est produite. Veuillez réessayer");
      }
    }
    return errorMessages;
  };

  return authService.getAccessToken().pipe(
    mergeMap((token) => {
      if (token && isPPUOriginUrl(req)) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }

      return next(req).pipe(
        catchError((error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401 || error.status === 403) {
              authService.logout().then();
            } else if (error.status == 400 || error.status == 0) {
              return throwError(() => processErrorMessages(error));
            }
          }
          return throwError(() => error);
        })
      );
    })
  );
};
